"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f595 = void 0;
exports.f595 = {
    "ɓàsàa": [
        626
    ],
    "ɓwaare": [
        683
    ],
    "ɓòkòtò": [
        704
    ],
    "ɓa ɓíilé": [
        845
    ],
    "ɓa": [
        845
    ],
    "ɓíilé": [
        845
    ],
    "ɓǎsɔ́ɔ̀": [
        1133,
        1132
    ],
    "ɓʉwa": [
        1244
    ],
    "ɓúúrák": [
        1290
    ],
    "ɓәna": [
        4374,
        8934
    ],
    "ɓə́ná-yungur": [
        8934
    ]
};
